import { render, staticRenderFns } from "./PinterestPlatformIcon.vue?vue&type=template&id=23a1eeeb&scoped=true"
import script from "./PinterestPlatformIcon.vue?vue&type=script&lang=js"
export * from "./PinterestPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1eeeb",
  null
  
)

export default component.exports